var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 43.75,
    fill: "#fff",
    stroke: "url(#2_svg__a)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__b)",
    d: "M52.05 64.949H35.457a.973.973 0 0 1-.966-.98V16.98c0-.54.433-.979.966-.979H52.05c.532 0 .965.439.965.98v46.99c0 .54-.432.979-.965.979m-15.63-1.96h14.665V17.96H36.421v45.033z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__c)",
    d: "M35.455 64.949h-14.49a.973.973 0 0 1-.965-.98V32.81c0-.377.212-.721.548-.883l14.49-7.036a.96.96 0 0 1 1.288.461.987.987 0 0 1-.456 1.307l-13.94 6.77v29.564h13.525c.533 0 .965.439.965.98s-.432.979-.965.979z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__d)",
    d: "M67.503 32.808v3.767h-1.929v-3.15l-13.942-6.769a.987.987 0 0 1-.455-1.306.96.96 0 0 1 1.288-.462l14.49 7.036a.98.98 0 0 1 .548.884"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__e)",
    d: "M65.575 58.362h1.929v5.607c0 .541-.43.98-.966.98h-14.49a.97.97 0 0 1-.963-.98c0-.54.43-.979.963-.979h13.527z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__f)",
    d: "M46.798 26.327h-6.092a.973.973 0 0 1-.965-.98c0-.54.432-.979.965-.979h6.092c.533 0 .965.439.965.98s-.432.979-.965.979"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__g)",
    d: "M46.798 33.889h-6.092a.973.973 0 0 1-.965-.98c0-.54.432-.979.965-.979h6.092c.533 0 .965.439.965.98s-.432.979-.965.979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__h)",
    d: "M46.798 41.453h-6.092a.973.973 0 0 1-.965-.98c0-.54.432-.98.965-.98h6.092c.533 0 .965.44.965.98s-.432.98-.965.98"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__i)",
    d: "M46.798 49.015h-6.092a.973.973 0 0 1-.965-.98c0-.54.432-.98.965-.98h6.092c.533 0 .965.44.965.98 0 .541-.432.98-.965.98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__j)",
    d: "M46.798 56.579h-6.092a.973.973 0 0 1-.965-.98c0-.54.432-.98.965-.98h6.092c.533 0 .965.44.965.98s-.432.98-.965.98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__k)",
    d: "M66.087 54.953a7.98 7.98 0 0 1-5.722-2.406c-3.156-3.201-3.156-8.408 0-11.61a7.98 7.98 0 0 1 5.722-2.405 7.98 7.98 0 0 1 5.722 2.405c3.156 3.202 3.156 8.409 0 11.61a7.98 7.98 0 0 1-5.722 2.406m0-14.495a6.1 6.1 0 0 0-4.381 1.841c-2.417 2.452-2.417 6.439 0 8.89a6.1 6.1 0 0 0 4.38 1.841 6.1 6.1 0 0 0 4.382-1.841c2.416-2.451 2.414-6.438 0-8.89a6.1 6.1 0 0 0-4.381-1.841"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2_svg__l)",
    d: "m71.808 51.19-1.34 1.36 4.926 4.999 1.341-1.361z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__a",
    x1: 0,
    x2: 89,
    y1: 89,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__b",
    x1: 30.52,
    x2: 55.001,
    y1: 49.215,
    y2: 49.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__c",
    x1: 16.481,
    x2: 38.18,
    y1: 52.043,
    y2: 52.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__d",
    x1: 47.564,
    x2: 69.262,
    y1: 32.788,
    y2: 32.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__e",
    x1: 47.567,
    x2: 69.263,
    y1: 62.832,
    y2: 62.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__f",
    x1: 38.022,
    x2: 48.623,
    y1: 25.697,
    y2: 25.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__g",
    x1: 38.022,
    x2: 48.623,
    y1: 33.259,
    y2: 33.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__h",
    x1: 38.022,
    x2: 48.623,
    y1: 40.823,
    y2: 40.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__i",
    x1: 38.022,
    x2: 48.623,
    y1: 48.385,
    y2: 48.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__j",
    x1: 38.022,
    x2: 48.623,
    y1: 55.949,
    y2: 55.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__k",
    x1: 54.531,
    x2: 75.909,
    y1: 49.675,
    y2: 49.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__l",
    x1: 73.523,
    x2: 75.321,
    y1: 56.233,
    y2: 54.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })))));
};
export default Svg2;